import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BankAccount } from 'src/app/models/bank-account/bank-account';
import { environment } from 'src/environments/environment';
import { BaseListResponse } from 'src/app/core/models/responses/base-list-response';
import { Observable } from 'rxjs';
import { Customer } from 'src/app/models/customer/customer';
import { BankAccountFilter } from 'src/app/models/filters/bank-account-filter';
import { BaseService } from '../core/services/base.service';
import { BaseResponse } from 'src/app/core/models/responses/base-response';
     
  
@Injectable({
  providedIn: 'root'
})
export class BankAccountService extends BaseService<BankAccount, BankAccountFilter, number> {

  constructor(private http:HttpClient){
    super(http, environment.urlAddress + '/BankAccount')
  }

  
  getDebtRecievableList(branchId: number): Observable<BaseListResponse<Customer>>{
    return this._http.get<BaseListResponse<Customer>>(this._base + "/customers-debt-receivable/" + branchId)
  }

  createCasesBulk(filter: BankAccountFilter): Observable<BaseResponse<{ createdCount: number }>>{
    return this._http.post<BaseResponse<{ createdCount: number }>>(this._base + "/create-cases-bulk", filter);
  }
}